 import { styled } from "@mui/material/styles";

 const StyledEditBrandDetails = styled("div")(
   ({ theme }) => `
    .topic-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 20px;
      font-style: normal;
      line-height: 100%;
    }   
    .create-profile-topics {
      background: ${theme.palette.customColor.white};
      padding: 15px 40px;
      border-radius: 0px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      @media screen and (max-width: 600px) {
        padding: 15px 5px;
      }
    }
    .topic-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 20px;
      font-style: normal;
      line-height: 20px;
    }

    .create-textfeilds {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .image-wrap {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      justify-content: center;
      margin: 20px 0px;
      cursor: pointer;
    }
    .profile-picture-image {
        border-radius: 3.56px;
        border: 1.24px solid #A78D78;
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .image-close {
    position: absolute;
    border-radius: 50%;
    background-color: #A78D78;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    top: -8px;
    right: -7px;
    cursor: pointer;
  }
  .profile-picture {
    border: 1.24px dashed #A78D78;
    border-radius: 3.56px;
    width: 86px;
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .add-icon {
    font-size: 40px;
    color: #A78D78
  }
  .cropped-image-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }  
  .cropped-image {
   width: 100%;
   height: 100%;
   object-fit: cover;
   border-radius: 3.56px;
  }  
  .modal-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .modal-content {
    width: 80%;
    height: 80%;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .image-crop-display {
    width: 100%;
    height: 80%;
  }
  .topic-header-2 {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 16px;
    font-style: normal;
    line-height: 100%;
    margin-bottom: 10px;
  }           

    `
 );

 export default StyledEditBrandDetails;
